module.exports = __webpack_public_path__ + "static/media/logo.5ff34c51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 51
// module chunks = 0